module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 512 209.4",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }